import { get } from 'utils/axios';
import { IExperienceSettingsResponse } from 'types/custom-questions';
import { IFullExperienceFields } from 'types/experience.types';

interface IExperienceResponse {
  data: IFullExperienceFields;
}

const fetchExperienceList = async (keyString: string) => {
  const { brandId, experienceIds, languageCode } = JSON.parse(keyString);

  const data = await Promise.all(
    experienceIds.map(async (experienceId: string) => {
      const [details, settings] = await Promise.all([
        get<IExperienceResponse>(
          `v1/brands/${brandId}/experiences/${experienceId}${
            languageCode ? `?language=${languageCode}` : ''
          }`,
        ),
        get<IExperienceSettingsResponse>(
          `v1/brands/${brandId}/experiences/${experienceId}/settings`,
        ),
      ]);

      return {
        ...details.data,
        ...settings.data,
      };
    }),
  );

  return data;
};

export default fetchExperienceList;
